// Help text explaining query syntax conventions
export const RESEARCH_QUERY_SYNTAX_HELP_TEXT =
  'Use <TABLE> for internal tables (e.g. <RESOURCE1>), "Column" for columns, "Column" for prefixed columns, and $$VAR$$ for variables.';

export const RULE_RESEARCH_QUERY_SYNTAX_HELP_TEXT =
  'Use <TABLE> for internal tables (e.g. <MISSING>), "Column" for columns, "Column" for prefixed columns, and $$VAR$$ for variables.';

export const GENERIC_EXTERNAL_QUERY_TEMPLATES = [
  'SELECT * FROM external_tbl a JOIN <RESOURCE1> b ON a.Col1 = b."Key1"',
  'SELECT * FROM <SUB_QUERY_NAME> a JOIN <RESOURCE1> b ON a.Column1 == b."Key1"',
];

export const GENERIC_RESOURCE_QUERY_TEMPLATES = [
  'SELECT * FROM <RESOURCE1> WHERE "Column1" = $$VAR$$',
];

export const RULE_RESOURCE_QUERY_TEMPLATES = [
  ...GENERIC_RESOURCE_QUERY_TEMPLATES,
];

export const RULE_EXTERNAL_QUERY_TEMPLATES = [
  'SELECT * FROM external_tbl a JOIN <MISMATCHED> b ON a.Col1 = b."Key1"',
  'SELECT * FROM external_tbl a JOIN <MISSING> b ON a.Col1 = b."Key1"',
  'SELECT * FROM <SUB_QUERY_NAME> a JOIN <MISSING> b ON a.Column1 == b."Key1"',
];

export const RULE_MERGED_QUERY_TEMPLATES = [
  'SELECT * FROM <MERGED_DATA> a JOIN <RESOURCE1> b ON a."Key1" = b."Column1"',
];

export const RULE_MISSING_DATA_QUERY_TEMPLATES = [
  'SELECT * FROM <MISSING> a JOIN <RESOURCE1> b ON a."Key1" = b."Column1"',
  'SELECT * FROM <MISSING> WHERE "Key1" IS NOT NULL',
];

export const RULE_MISMATCHED_DATA_QUERY_TEMPLATES = [
  'SELECT * FROM <MISMATCHED> a JOIN <RESOURCE1> b ON a."Key1" = b."Column1"',
  'SELECT * FROM <MISMATCHED> WHERE "Key1" IS NOT NULL',
];
